import { c as compute_rest_props, b as compute_slots, s as subscribe } from "../../../chunks/utils.js";
import { c as create_ssr_component, f as createEventDispatcher, s as spread, a as escape_attribute_value, b as escape_object, d as add_attribute, v as validate_component, h as setContext, g as getContext, e as escape, i as each } from "../../../chunks/ssr.js";
/* empty css                  */
import { u as user, t as token } from "../../../chunks/auth.js";
import { u as userCustomer, c as currentCustomer } from "../../../chunks/customer.js";
import { P as PUBLIC_AUTH_ENDPOINT } from "../../../chunks/public.js";
import { p as page } from "../../../chunks/stores.js";
import { g as get } from "../../../chunks/api.js";
import { f as fullCustomer } from "../../../chunks/customer2.js";
import { w as writable } from "../../../chunks/index2.js";
import { twMerge } from "tailwind-merge";
import { C as CloseButton } from "../../../chunks/CloseButton.js";
import { B as Button } from "../../../chunks/Button.js";
import { H as Heading } from "../../../chunks/Heading.js";
import { D as Dropdown } from "../../../chunks/Dropdown.js";
import { D as DropdownItem } from "../../../chunks/DropdownItem.js";
import { I as IconSolid } from "../../../chunks/IconSolid.js";
import "../../../chunks/client.js";
import { T as Tooltip } from "../../../chunks/Tooltip.js";
import { s as sideMenuItems } from "../../../chunks/sideMenuItems.js";
import "iconify-icon";
import { c as currentRoute } from "../../../chunks/route.js";
const Banner = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let div2Class;
  let $$restProps = compute_rest_props($$props, ["position", "dismissable", "bannerType", "divClass", "innerClass"]);
  let { position = "sticky" } = $$props;
  let { dismissable = true } = $$props;
  let { bannerType = "default" } = $$props;
  let { divClass = "z-10 flex justify-between p-4 dark:bg-gray-700 dark:border-gray-600" } = $$props;
  let { innerClass = "flex" } = $$props;
  const dispatch = createEventDispatcher();
  const divClasses = {
    default: "top-0 start-0 w-full border-b border-gray-200 bg-gray-50",
    bottom: "bottom-0 start-0 w-full border-t border-gray-200 bg-gray-50",
    cta: "flex-col md:flex-row  w-[calc(100%-2rem)] -translate-x-1/2 rtl:translate-x-1/2 bg-white border border-gray-100 rounded-lg shadow-sm lg:max-w-7xl start-1/2 top-6",
    signup: "top-0 start-0 w-full border-b border-gray-200 bg-gray-50",
    info: "top-0 start-0 flex-col w-full border-b border-gray-200 md:flex-row bg-gray-50"
  };
  const insideDivClasses = {
    default: "items-center mx-auto",
    bottom: "items-center mx-auto",
    cta: "flex-col items-start mb-3 me-4 md:items-center md:flex-row md:mb-0",
    signup: "items-center flex-shrink-0 w-full mx-auto sm:w-auto",
    info: "items-center flex-shrink-0"
  };
  if ($$props.position === void 0 && $$bindings.position && position !== void 0) $$bindings.position(position);
  if ($$props.dismissable === void 0 && $$bindings.dismissable && dismissable !== void 0) $$bindings.dismissable(dismissable);
  if ($$props.bannerType === void 0 && $$bindings.bannerType && bannerType !== void 0) $$bindings.bannerType(bannerType);
  if ($$props.divClass === void 0 && $$bindings.divClass && divClass !== void 0) $$bindings.divClass(divClass);
  if ($$props.innerClass === void 0 && $$bindings.innerClass && innerClass !== void 0) $$bindings.innerClass(innerClass);
  {
    dispatch("open");
  }
  divClass = twMerge(position, divClass, divClasses[bannerType], $$props.classDiv);
  div2Class = twMerge(innerClass, insideDivClasses[bannerType], $$props.classInner);
  return `${`<div${spread(
    [
      { tabindex: "-1" },
      { class: escape_attribute_value(divClass) },
      escape_object($$restProps)
    ],
    {}
  )}>${slots.header ? slots.header({}) : ``} <div${add_attribute("class", div2Class, 0)}>${slots.default ? slots.default({}) : ``}</div> ${dismissable ? `<div class="flex items-center">${validate_component(CloseButton, "CloseButton").$$render(
    $$result,
    {
      class: "-mx-1.5 -my-1.5",
      color: $$restProps.color
    },
    {},
    {}
  )}</div>` : ``}</div>`} `;
});
const Sidebar$1 = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["activeUrl", "asideClass", "nonActiveClass", "activeClass", "ariaLabel"]);
  const activeUrlStore = writable("");
  let { activeUrl = "" } = $$props;
  let { asideClass = "w-64" } = $$props;
  let { nonActiveClass = "flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700" } = $$props;
  let { activeClass = "flex items-center p-2 text-base font-normal text-gray-900 bg-gray-200 dark:bg-gray-700 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700" } = $$props;
  let { ariaLabel = "Sidebar" } = $$props;
  setContext("sidebarContext", { activeClass, nonActiveClass });
  setContext("activeUrl", activeUrlStore);
  if ($$props.activeUrl === void 0 && $$bindings.activeUrl && activeUrl !== void 0) $$bindings.activeUrl(activeUrl);
  if ($$props.asideClass === void 0 && $$bindings.asideClass && asideClass !== void 0) $$bindings.asideClass(asideClass);
  if ($$props.nonActiveClass === void 0 && $$bindings.nonActiveClass && nonActiveClass !== void 0) $$bindings.nonActiveClass(nonActiveClass);
  if ($$props.activeClass === void 0 && $$bindings.activeClass && activeClass !== void 0) $$bindings.activeClass(activeClass);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    {
      activeUrlStore.set(activeUrl);
    }
  }
  return `<aside${spread(
    [
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge(asideClass, $$props.class))
      },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      }
    ],
    {}
  )}>${slots.default ? slots.default({}) : ``}</aside> `;
});
const SidebarItem = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let active;
  let aClass;
  let $$restProps = compute_rest_props($$props, ["href", "label", "spanClass", "activeClass", "nonActiveClass"]);
  let $$slots = compute_slots(slots);
  let { href = "" } = $$props;
  let { label = "" } = $$props;
  let { spanClass = "ms-3" } = $$props;
  let { activeClass = void 0 } = $$props;
  let { nonActiveClass = void 0 } = $$props;
  const context = getContext("sidebarContext") ?? {};
  const activeUrlStore = getContext("activeUrl");
  let sidebarUrl = "";
  activeUrlStore.subscribe((value) => {
    sidebarUrl = value;
  });
  if ($$props.href === void 0 && $$bindings.href && href !== void 0) $$bindings.href(href);
  if ($$props.label === void 0 && $$bindings.label && label !== void 0) $$bindings.label(label);
  if ($$props.spanClass === void 0 && $$bindings.spanClass && spanClass !== void 0) $$bindings.spanClass(spanClass);
  if ($$props.activeClass === void 0 && $$bindings.activeClass && activeClass !== void 0) $$bindings.activeClass(activeClass);
  if ($$props.nonActiveClass === void 0 && $$bindings.nonActiveClass && nonActiveClass !== void 0) $$bindings.nonActiveClass(nonActiveClass);
  active = sidebarUrl ? href === sidebarUrl : false;
  aClass = twMerge(
    active ? activeClass ?? context.activeClass : nonActiveClass ?? context.nonActiveClass,
    $$props.class
  );
  return `<li><a${spread(
    [
      escape_object($$restProps),
      { href: escape_attribute_value(href) },
      { class: escape_attribute_value(aClass) }
    ],
    {}
  )}>${slots.icon ? slots.icon({}) : ``} <span${add_attribute("class", spanClass, 0)}>${escape(label)}</span> ${$$slots.subtext ? `${slots.subtext ? slots.subtext({}) : ``}` : ``}</a></li> `;
});
const SidebarGroup = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["ulClass", "borderClass", "border"]);
  let { ulClass = "space-y-2" } = $$props;
  let { borderClass = "pt-4 mt-4 border-t border-gray-200 dark:border-gray-700" } = $$props;
  let { border = false } = $$props;
  if (border) {
    ulClass += " " + borderClass;
  }
  if ($$props.ulClass === void 0 && $$bindings.ulClass && ulClass !== void 0) $$bindings.ulClass(ulClass);
  if ($$props.borderClass === void 0 && $$bindings.borderClass && borderClass !== void 0) $$bindings.borderClass(borderClass);
  if ($$props.border === void 0 && $$bindings.border && border !== void 0) $$bindings.border(border);
  return `<ul${spread(
    [
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge(ulClass, $$props.class))
      }
    ],
    {}
  )}>${slots.default ? slots.default({}) : ``}</ul> `;
});
const SidebarWrapper = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["divClass"]);
  let { divClass = "overflow-y-auto py-4 px-3 bg-gray-50 rounded dark:bg-gray-800" } = $$props;
  if ($$props.divClass === void 0 && $$bindings.divClass && divClass !== void 0) $$bindings.divClass(divClass);
  return `<div${spread(
    [
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge(divClass, $$props.class))
      }
    ],
    {}
  )}>${slots.default ? slots.default({}) : ``}</div> `;
});
const AdjustmentsHorizontalSolid = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "adjustments horizontal solid" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path d="M10.83 5a3.001 3.001 0 0 0-5.66 0H4a1 1 0 1 0 0 2h1.17a3.001 3.001 0 0 0 5.66 0H20a1 1 0 1 0 0-2h-9.17ZM4 11h9.17a3.001 3.001 0 0 1 5.66 0H20a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H4a1 1 0 1 1 0-2Zm1.17 6H4a1 1 0 1 0 0 2h1.17a3.001 3.001 0 0 0 5.66 0H20a1 1 0 1 0 0-2h-9.17a3.001 3.001 0 0 0-5.66 0Z"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path d="M10.83 5a3.001 3.001 0 0 0-5.66 0H4a1 1 0 1 0 0 2h1.17a3.001 3.001 0 0 0 5.66 0H20a1 1 0 1 0 0-2h-9.17ZM4 11h9.17a3.001 3.001 0 0 1 5.66 0H20a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H4a1 1 0 1 1 0-2Zm1.17 6H4a1 1 0 1 0 0 2h1.17a3.001 3.001 0 0 0 5.66 0H20a1 1 0 1 0 0-2h-9.17a3.001 3.001 0 0 0-5.66 0Z"></path></svg>`} `;
});
const sideMenuEnabled = writable(true);
const NavAuthor = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let user_associate;
  let author;
  let $page, $$unsubscribe_page;
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  user_associate = $page.data.user_info?.associations.find((associate) => associate.userId === $page.data.user_info.id);
  author = user_associate || {
    name: "@" + $page.data.user_info?.email?.split("@")[0]
  };
  $$unsubscribe_page();
  return `<div class="relative"><div class="text-neutral-400 whitespace-nowrap">${escape(author.name)}</div> <div class="flex gap-3 flex-1 text-xs align-items-center items-center text-neutral-600 dark:text-gray-300"><span>${escape(user_associate?.customer?.name)}</span> <svg class="w-3 h-3 text-gray-800 dark:text-white cursor-pointer" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20"><path d="M18 7.5h-.423l-.452-1.09.3-.3a1.5 1.5 0 0 0 0-2.121L16.01 2.575a1.5 1.5 0 0 0-2.121 0l-.3.3-1.089-.452V2A1.5 1.5 0 0 0 11 .5H9A1.5 1.5 0 0 0 7.5 2v.423l-1.09.452-.3-.3a1.5 1.5 0 0 0-2.121 0L2.576 3.99a1.5 1.5 0 0 0 0 2.121l.3.3L2.423 7.5H2A1.5 1.5 0 0 0 .5 9v2A1.5 1.5 0 0 0 2 12.5h.423l.452 1.09-.3.3a1.5 1.5 0 0 0 0 2.121l1.415 1.413a1.5 1.5 0 0 0 2.121 0l.3-.3 1.09.452V18A1.5 1.5 0 0 0 9 19.5h2a1.5 1.5 0 0 0 1.5-1.5v-.423l1.09-.452.3.3a1.5 1.5 0 0 0 2.121 0l1.415-1.414a1.5 1.5 0 0 0 0-2.121l-.3-.3.452-1.09H18a1.5 1.5 0 0 0 1.5-1.5V9A1.5 1.5 0 0 0 18 7.5Zm-8 6a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Z"></path></svg></div></div> ${validate_component(Dropdown, "Dropdown").$$render($$result, {}, {}, {
    default: () => {
      return `${validate_component(DropdownItem, "DropdownItem").$$render($$result, { href: "/settings" }, {}, {
        default: () => {
          return `<i class="las la-cog"></i>
        Settings`;
        }
      })} ${validate_component(DropdownItem, "DropdownItem").$$render($$result, { href: "/logout" }, {}, {
        default: () => {
          return `<i class="las la-sign-out-alt"></i> Sign Out`;
        }
      })}`;
    }
  })}`;
});
const Sidebar = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $user, $$unsubscribe_user;
  let $page, $$unsubscribe_page;
  $$unsubscribe_user = subscribe(user, (value) => $user = value);
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  let { displayMenuText = true } = $$props;
  let urlPath;
  const menus = sideMenuItems.filter((x) => $user?.scope?.includes(x.href));
  if ($$props.displayMenuText === void 0 && $$bindings.displayMenuText && displayMenuText !== void 0) $$bindings.displayMenuText(displayMenuText);
  urlPath = $page.url.pathname;
  $$unsubscribe_user();
  $$unsubscribe_page();
  return `${validate_component(Sidebar$1, "FlowbiteSidebar").$$render($$result, { class: "bg-transparent", asideClass: "" }, {}, {
    default: () => {
      return `${validate_component(SidebarWrapper, "SidebarWrapper").$$render($$result, { class: "bg-transparent" }, {}, {
        default: () => {
          return `${validate_component(SidebarGroup, "SidebarGroup").$$render($$result, {}, {}, {
            default: () => {
              return `${each(menus, (menu) => {
                return `${validate_component(SidebarItem, "SidebarItem").$$render(
                  $$result,
                  {
                    spanClass: displayMenuText ? "ml-3" : "",
                    href: menu.href,
                    label: displayMenuText ? menu.label : "",
                    active: menu.href === urlPath
                  },
                  {},
                  {
                    icon: () => {
                      return `${validate_component(IconSolid, "IconSolid").$$render(
                        $$result,
                        {
                          icon: menu.icon,
                          class: "w-5 h-5 " + (menu.href === urlPath ? "text-primary-600" : "text-gray-500") + " transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                        },
                        {},
                        {}
                      )} ${!displayMenuText ? `${validate_component(Tooltip, "Tooltip").$$render($$result, { class: "z-20", placement: "right" }, {}, {
                        default: () => {
                          return `${escape(menu.label)}`;
                        }
                      })}` : ``} `;
                    }
                  }
                )}`;
              })}`;
            }
          })}`;
        }
      })}`;
    }
  })}`;
});
const Layout = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $sideMenuEnabled, $$unsubscribe_sideMenuEnabled;
  let $currentCustomer, $$unsubscribe_currentCustomer;
  let $userCustomer, $$unsubscribe_userCustomer;
  let $currentRoute, $$unsubscribe_currentRoute;
  let $page, $$unsubscribe_page;
  $$unsubscribe_sideMenuEnabled = subscribe(sideMenuEnabled, (value) => $sideMenuEnabled = value);
  $$unsubscribe_currentCustomer = subscribe(currentCustomer, (value) => $currentCustomer = value);
  $$unsubscribe_userCustomer = subscribe(userCustomer, (value) => $userCustomer = value);
  $$unsubscribe_currentRoute = subscribe(currentRoute, (value) => $currentRoute = value);
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  let { data } = $$props;
  token.subscribe((val) => {
    if (!val && typeof window !== "undefined") {
      window.location = PUBLIC_AUTH_ENDPOINT + `?redirect=${window.location.origin}`;
    } else if (typeof window !== "undefined") {
      user.set(data.claim);
      get("/auth/me").then((res) => {
        if (!$userCustomer) {
          userCustomer.set(res.associations[0].customer);
        }
        if (!$currentCustomer) {
          currentCustomer.set(res.associations[0].customer);
        }
      });
    }
  });
  userCustomer.subscribe(async (val) => {
    if (val) {
      await fullCustomer(val.uuid);
    }
  });
  if ($$props.data === void 0 && $$bindings.data && data !== void 0) $$bindings.data(data);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(Banner, "Banner").$$render($$result, { bannerType: "info", dismissable: false }, {}, {
      header: () => {
        return `<div slot="header"><div class="flex gap-5"><nav class="min-w-[245px] flex gap-3 items-center pl-2"><a class="block max-w-max" href="/" data-svelte-h="svelte-1qq6ayu"><img src="/img/ci/button_recrew_solid_black.svg" class="max-h-12 w-12" alt=""></a> ${validate_component(NavAuthor, "NavAuthor").$$render($$result, {}, {}, {})}</nav> ${validate_component(Heading, "Heading").$$render(
          $$result,
          {
            tag: "h1",
            customSize: "text-2xl",
            class: "flex gap-3 items-center pl-4 text-neutral-600"
          },
          {},
          {
            default: () => {
              return `${$currentRoute ? `${validate_component(IconSolid, "IconSolid").$$render($$result, { icon: $currentRoute.icon }, {}, {})}` : ``} ${escape($page.data.page_title || $currentRoute?.label)}`;
            }
          }
        )}</div></div>`;
      }
    })} <main class="main-content flex flex-1"><div${add_attribute("class", $sideMenuEnabled ? "w-[280px]" : "", 0)}><div class="grid px-3 mt-4">${validate_component(Button, "Button").$$render($$result, { size: "xs", color: "alternative" }, {}, {
      default: () => {
        return `${validate_component(IconSolid, "IconSolid").$$render(
          $$result,
          {
            icon: AdjustmentsHorizontalSolid,
            size: "xs"
          },
          {},
          {}
        )}`;
      }
    })}</div> ${validate_component(Sidebar, "Sidebar").$$render(
      $$result,
      { displayMenuText: $sideMenuEnabled },
      {
        displayMenuText: ($$value) => {
          $sideMenuEnabled = $$value;
          $$settled = false;
        }
      },
      {}
    )}</div> <div class="flex-1 pt-3 mb-5 px-4">${slots.default ? slots.default({}) : ``}</div></main>`;
  } while (!$$settled);
  $$unsubscribe_sideMenuEnabled();
  $$unsubscribe_currentCustomer();
  $$unsubscribe_userCustomer();
  $$unsubscribe_currentRoute();
  $$unsubscribe_page();
  return $$rendered;
});
export {
  Layout as default
};
//# sourceMappingURL=_layout.svelte.js.map
